import {RefObject, useEffect} from 'react';
import {FormikHelpers, FormikValues} from 'formik';

type googleAutocompleteParams = {
  mainAddressField: RefObject<HTMLInputElement>;
  setFieldValue: Pick<FormikHelpers<FormikValues>, 'setFieldValue'>['setFieldValue'];
  line1: string;
};

const useGoogleAutocomplete = ({mainAddressField, setFieldValue, line1}: googleAutocompleteParams) => {
  useEffect(() => {
    if (!mainAddressField.current) {
      return;
    }

    const autoComplete = new window.google.maps.places.Autocomplete(mainAddressField.current, {
      componentRestrictions: {country: 'us'},
      fields: ['formatted_address', 'address_components', 'geometry'],
      types: ['address'],
      strictBounds: false,
    });

    autoComplete.addListener('place_changed', () => {
      const addressObject = autoComplete.getPlace();
      const responseQuery = addressObject.formatted_address;

      if (responseQuery) {
        setFieldValue('address.line1', responseQuery.split(',')[0]);
      }

      addressObject?.address_components?.forEach((component) => {
        const componentType = component.types[0];

        switch (componentType) {
          case 'postal_code':
            setFieldValue('address.zip', component.short_name);
            break;
          case 'locality':
            setFieldValue('address.city', component.long_name);
            break;
          case 'administrative_area_level_1':
            setFieldValue('address.state', component.short_name);
            break;
          default:
            break;
        }
      });
    });
  }, [line1]);
};

export default useGoogleAutocomplete;
